import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@wds/grid';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { removeQueryParameters, stripHttp } from '~app/pages/AppsDirectory/components/utils';
import useStyles from '../styles';

export const AppDetailsFooter = ({ appDetails }) => {
  const { footerColumn } = useStyles();
  return (
    <Grid px={8} py={4} mb={6}>
      <Grid.Item sm={3}>
        <Box className={footerColumn}>
          <Typography variant="cardTitle">Email</Typography>
          <Typography variant="body">
            <a href={`mailto:${appDetails.supportEmail}`}>{appDetails.supportEmail}</a>
          </Typography>
        </Box>
      </Grid.Item>
      <Grid.Item sm={3}>
        <Box className={footerColumn}>
          <Typography variant="cardTitle">Privacy</Typography>
          <Typography variant="body">
            <a href={appDetails.privacyPolicyUrl}>{stripHttp(removeQueryParameters(appDetails.privacyPolicyUrl))}</a>
          </Typography>
        </Box>
      </Grid.Item>
      <Grid.Item sm={3}>
        <Box className={footerColumn}>
          <Typography variant="cardTitle">Terms of service</Typography>
          <Typography variant="body">
            <a href={appDetails.termsOfUseUrl}>{stripHttp(removeQueryParameters(appDetails.termsOfUseUrl))}</a>
          </Typography>
        </Box>
      </Grid.Item>
    </Grid>
  );
};

AppDetailsFooter.propTypes = {
  appDetails: PropTypes.shape({
    publisher: PropTypes.string,
    featureList: PropTypes.arrayOf(PropTypes.string),
    googleAnalyticsTrackingId: PropTypes.string,
    supportEmail: PropTypes.string,
    supportPhoneNumber: PropTypes.string,
    supportUrl: PropTypes.string,
    requirements: PropTypes.arrayOf(PropTypes.string),
    screenshots: PropTypes.arrayOf(PropTypes.string),
    privacyPolicyUrl: PropTypes.string,
    termsOfUseUrl: PropTypes.string,
    blogUrl: PropTypes.string,
    youtubeUrl: PropTypes.string,
    websiteUrl: PropTypes.string,
    installUrl: PropTypes.string,
    upgradeRequired: PropTypes.bool,
    optionalUpgrade: PropTypes.bool,
    scopes: PropTypes.arrayOf(PropTypes.string),
    link: PropTypes.string,
    linkType: PropTypes.string,
  }).isRequired,
};

export default AppDetailsFooter;
